import React, { FC } from 'react';
import { UseFormMethods } from 'react-hook-form';
import { InputProps, FormControl, FormLabel, Input, FormErrorMessage } from '@chakra-ui/react';

interface IReactFormInputProps extends InputProps {
	formProp: UseFormMethods<any>;
	label: string;
}

export const ReactFormInput: FC<IReactFormInputProps> = (props) => {
	const { formProp, label, ...inputProps } = props;
	const id = inputProps.id || inputProps.name;
	const name = inputProps.name || '';

	return (
		<FormControl isInvalid={!!formProp.errors[name]}>
			<FormLabel htmlFor={id} mt={2}>
				{label}
			</FormLabel>
			<Input size="sm" ref={formProp.register} id={id} {...inputProps} />
			<FormErrorMessage>{formProp.errors[name]?.message}</FormErrorMessage>
		</FormControl>
	);
};
